export default __webpack_public_path__ + "static/media/logo-footer.fe0f72fc.svg";